import { State } from 'src/redux/reducer';

export const allUsersAdministrationSelector = (state: State) =>
  state.allUsersAdministration;
